import { BASE_URL, BASE_USER_INFO, MAP_LOADED } from './mutations-type.js'
// import { jumpLoginPage } from '@/assets/js/jumpLogin.js'
import { loadSudoku } from '@/assets/js/loadSudoku.js'
import {
  initConfig,
  userInfo
} from '@/service/base.js'
import axios from 'axios'
import Vue from 'vue'
export default {
  async getInitConfig ({ commit }) {
    let lastVersion = localStorage.getItem('lastCCVersion')
    let currentVersion = localStorage.getItem('newCCVersion')
    let newCCConfig = localStorage.getItem('newCCInitConfig')
    // 判断是否更新重新请求接口
    if (lastVersion != currentVersion || !newCCConfig) {
      const res = await initConfig()
      const { result, errorCode } = res.data
      if (errorCode == '0x0') {
        let portForhttpOrHttps = result.portForhttpOrHttps ? result.portForhttpOrHttps : []
        // 设置url存储在store中
        if (window.location.protocol === 'https:') {
          Object.keys(result).forEach(key => {
            portForhttpOrHttps.map(v => {
              if (v.key == key) {
                if (typeof result[key] == 'string') {
                  result[key] = result[key].replace(v.http, v.https)
                }
              }
            })
          })
        }
        // 设置MediaService及what's New需要的参数
        loadSudoku(result)
        Vue.prototype.$TVU = {
          http: axios,
          serverName: 'CommandCenter',
          userAuthUrl: result.userAuthUrl, // 后端配置的url地址
          versionNewsCode: result.versionCode,
          userGroup: result.versionApiUrl
        }
        let val = { urlInfo: result }
        localStorage.setItem('newCCInitConfig', JSON.stringify(val))
        // 设置上一次版本号
        localStorage.setItem('lastCCVersion', currentVersion)
        // configT地址
        localStorage.setItem('newCCUrl', result.mySourceUrl)
        // 设置url存储在store中
        commit(BASE_URL, val)
        // await dispatch('getUserInfo')
      }
    } else {
      let newCCInitConfig = JSON.parse(localStorage.getItem('newCCInitConfig'))
      // 设置url存储在store中
      const result = newCCInitConfig.urlInfo
      // 用于tvu-common-components的传参
      loadSudoku(result)
      Vue.prototype.$TVU = {
        http: axios,
        serverName: 'CommandCenter',
        userAuthUrl: result.userAuthUrl, // 后端配置的url地址
        versionNewsCode: result.versionCode,
        userGroup: result.versionApiUrl
      }
      // 设置url存储在store中
      commit(BASE_URL, { urlInfo: result })
      // await dispatch('getUserInfo')
    }
  },
  async getInitConfigFn ({ dispatch }) {
    await dispatch('getInitConfig')
  },
  async getUserInfo ({ commit }) {
    try {
      const res = await userInfo()
      if (res.data.errorCode === '0x0') {
        const data = res.data.result ? { userInfo: res.data.result } : {}

        // 存储token（如果有）
        if (res.data.result?.pagePermissionInfo?.tk) {
          localStorage.setItem('NewCCsession3.0', window.atob(res.data.result.pagePermissionInfo.tk))
        }

        commit(BASE_USER_INFO, data)
      } else if (res.data.errorCode === '80000302') {
        window.location.href = res.errorInfo
      }
    } catch (error) {
    }
  },
  mapLoad ({ commit, state, rootState }) {
    commit(MAP_LOADED, 'true')
  }
}
